import { RouterOutput } from '@/server/types/infer-trpc-types';
import { api } from '@/utils/api';

export type OrderAttachment =
    RouterOutput['platoUser']['grid']['getDetailQuoteOrder']['getSalesDocuments'][number];

export const useOrderAttachments = ({ transactionId }: { transactionId: string }) => {
    return api.platoUser.grid.getDetailQuoteOrder.getSalesDocuments.useQuery(
        {
            id: transactionId,
        },
        {
            refetchOnMount: false,
        },
    );
};
